import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const teamLeadPayoutSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({        
        getTeamleadPayoutDetails: builder.query({
            query: (arg: any) => {
                const { employeeNumber,year, month,scorecardVersionId,scorecardRoleId} = arg;
                return {
                    url: constants.TEAMLEAD_PAYOUT_DETAILS,
                    params: { employeeNumber,year, month,scorecardVersionId,scorecardRoleId },
                };
            },
        }),
    }),
});
export const { useGetTeamleadPayoutDetailsQuery } = teamLeadPayoutSlice;